import { render, staticRenderFns } from "./dropdown_api.vue?vue&type=template&id=731645e0&scoped=true&"
import script from "./dropdown_api.vue?vue&type=script&lang=js&"
export * from "./dropdown_api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731645e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731645e0')) {
      api.createRecord('731645e0', component.options)
    } else {
      api.reload('731645e0', component.options)
    }
    module.hot.accept("./dropdown_api.vue?vue&type=template&id=731645e0&scoped=true&", function () {
      api.rerender('731645e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/abstracts/dropdown_api.vue"
export default component.exports